import { render, staticRenderFns } from "./bivar.vue?vue&type=template&id=f565bab2&"
import script from "./bivar.vue?vue&type=script&lang=js&"
export * from "./bivar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports